import { render, staticRenderFns } from "./typeNavs.vue?vue&type=template&id=0a2fe557&scoped=true&"
import script from "./typeNavs.vue?vue&type=script&lang=js&"
export * from "./typeNavs.vue?vue&type=script&lang=js&"
import style0 from "./typeNavs.vue?vue&type=style&index=0&id=0a2fe557&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2fe557",
  null
  
)

export default component.exports